
/*
    Values and functions commonly used within the API requests:
    - base URL for those requests
    - method for creating the expected format for data parameters to those requests
    - method for converting js objects into FormData for POST requests
*/

import Axios from "axios";

// const BaseURL = "http://10.20.21.40:8070";
// const BaseURL = window.ENDPOINT_KEY ? window.ENDPOINT_KEY.trim() : "https://TESTPCSData.njtransit.com";
const BaseURL = window.ENDPOINT_KEY ? window.ENDPOINT_KEY.trim() : "https://pcsdata.prod.njtransit.com";

// will only last for the current session,
// rather than being put in local storage
let SSO_Token = null;

export const setSSOToken = (token) => {
    SSO_Token = token;
}

console.log("CAN WE SEE THE ENV?", window.ENDPOINT_KEY);

let timeoutCount = 0;
let testInterval = null;
let normalOperation = true;
let isDisconnected = false;
let isServerError = false;
const timeoutLimit = 3;

//
// be sure to only call the functions when the state changes
//
export function keepTestingConnection(disconnectedFunc, serverErrorFunc, returnToSuccessFunc) {

    const testConnection = () => {
        Axios.get(`${BaseURL}/api/Error/getState`, {timeout: 2000})
        .then(({data}) => {
            timeoutCount = 0;
            if(data && data === "Working"){
                if(!normalOperation){
                    returnToSuccessFunc();
                }
                normalOperation = true;
                isDisconnected = false;
                isServerError = false;
            }
            else{
                if(!isServerError){
                    serverErrorFunc();
                }
                normalOperation = false;
                isServerError = true;
                isDisconnected = false;
            }
        })
        .catch(err => {
            timeoutCount++;
            if(timeoutCount >= timeoutLimit && !isDisconnected){
                isDisconnected = true;
                disconnectedFunc();
            }
            normalOperation = false;
            isServerError = false;
        });
    }

    testInterval = setInterval(testConnection, 2000);
}

export function stopTestingConnection(stopFunc){
    if(testInterval){
        clearInterval(testInterval);
    }
}

//
//
function createDateString(date){
    return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();
}

//
//
function createFormData(params, noKey = false, requestName) {
    const fd = new FormData();

    Object.keys(params).forEach((key) => {
        let val = params[key];
        if(!val && val !== 0 && val !== false){
            val = "";
        } 
        console.log("add key", key, val, requestName);
        fd.append(key, val);
    });

    const key = getAPIKey();
    
    if(key && !noKey){
        console.log("API KEY", typeof key, key.length, key, requestName);
        fd.append("token", key);
    }

    return fd;
}

//
//
const getAPIKey = () => {
    return SSO_Token || localStorage.getItem("__user_api_key__");
}

export default class BaseValues {
    static createDateString = createDateString;
    static createFormData = createFormData;

    static get BaseURL(){
        return BaseURL;
    }

    static get APIKey(){
        return getAPIKey();
    }
};